export function getBatchStatus (batch, taskSummary) {
  if (!batch) return { label: 'Unknown', className: '', icon: 'help', iconColor: 'gray' }
  if (batch.isError) return { label: 'Failed', className: 'errored', icon: 'close', iconColor: 'red' }
  if (batch.isProcessing) return { label: 'Processing', className: 'processing', icon: 'sync', iconColor: 'blue' }
  if (batch.lastFinishedDate) return { label: 'Completed', className: 'complete', icon: 'check', iconColor: 'green' }
  const total = taskSummary?.total ?? batch.taskSummary?.total ?? 0
  if (total > 0) return { label: 'Awaiting Review', className: 'idle', icon: 'hand', iconColor: 'orange' }
  return { label: 'Awaiting Upload', className: 'idle', icon: 'cloudUpload', iconColor: 'gray' }
}

export const statusColorStyles = {
  '&.errored': { backgroundColor: 'var(--color-danger-050)', color: 'var(--color-danger-500)' },
  '&.processing': { backgroundColor: 'var(--color-primary-050)', color: 'var(--color-primary-500)' },
  '&.idle': { backgroundColor: 'var(--color-warning-050)', color: 'var(--color-warning-500)' },
  '&.complete': { backgroundColor: 'var(--color-success-050)', color: 'var(--color-success-500)' }
}
